export default {"src":"/_next/static/media/arrow-right.3c6fb8e0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};